import { motion } from "framer-motion";
import { ShieldCheck, Clock, GraduationCap, CurrencyInr, ThumbsUp } from "@phosphor-icons/react";

const features = [
  { Icon: ShieldCheck, title: "Verified & Background Checked", desc: "Every staff member is police-verified and vetted before placement." },
  { Icon: Clock, title: "On-Time Service", desc: "Punctual, dependable help that respects your schedule." },
  { Icon: GraduationCap, title: "Trained Professionals", desc: "Skilled, well-mannered staff trained for your home." },
  { Icon: CurrencyInr, title: "Affordable Pricing", desc: "Transparent, fair rates with no hidden charges." },
  { Icon: ThumbsUp, title: "100% Customer Satisfaction", desc: "We don't rest until you're completely happy." },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="py-24 md:py-32 bg-[var(--navy)] text-white relative overflow-hidden grain" data-testid="why">
      <div className="pointer-events-none absolute -right-32 top-10 h-96 w-96 rounded-full bg-[var(--gold)]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="label-caps text-[var(--gold)] mb-4">Why Choose Us</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">
              Trusted care, <br />
              <span className="text-[var(--gold)] italic">delivered right.</span>
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed max-w-sm">
              We treat your home like our own. That&apos;s the Quick Maid promise —
              professional care for your home &amp; family.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {features.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 hover:bg-white/10 transition-colors ${
                  i === 4 ? "sm:col-span-2" : ""
                }`}
                data-testid={`feature-${i}`}
              >
                <div className="flex items-center gap-4">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-[var(--gold)] text-[var(--navy)] shrink-0">
                    <f.Icon weight="fill" size={26} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl">{f.title}</h3>
                    <p className="text-sm text-white/65 mt-1 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
